'use client';

import dynamic from 'next/dynamic';

import { SolarSliderType } from '../../../types/storyblok';

export const SolarSlider = dynamic<SolarSliderType>(async () => import('./SolarSliderInner'), { ssr: true });
